<template>
  <div class="grid grid-cols-5 gap-4  w-auto md:gap-8 m-8"> 
    <div class="grid   ">
       <div class="text-center firstbox grid grid-cols-2 bg-blue-100 gap-2 " >
            <i class="fas fa-globe icon-wrapper md:ml-3 lg:ml-9 xl:ml-14 2xl:ml-14" style="color:blue;" ></i>  
       <br>
          <h5 class="lg:ml-6 xl:ml-12 2xl:ml-12" style="color:black;">Profile</h5>  
      </div>

    <div class="grid  grid-cols-1  gap-1  ">
        <div>
        <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1 mt-3 ">
     <i class="fas fa-tools md:ml-2 lg:ml-10  xl:ml-14" style="color: pink"> 
          </i>
          &nbsp;&nbsp; &nbsp; &nbsp;
          <h4>Product</h4>
      <!-- <div class="icon-wrapper" style="color: purple">
          <i class="fas fa-tools"> 
            <h3>Product</h3>
          </i> 
        </div> -->
      </div>
       </a>
        </div>

  <div>
     <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-cogs md:ml-2 lg:ml-10  xl:ml-14" style="color:rgb(195, 38, 226)"> </i> 
         &nbsp;&nbsp;&nbsp; &nbsp;
          <h4 title="Tally on cloud"  id="content">Tally on cloud</h4>
      </div>
       </a>
       </div>
  <div>
            <jet-nav-link   :href="'/integrate?is_license_valid='+is_valid_license+'&is_electron='+is_electron+'&license_from_database='+license_no" class="d-flex justify-start box1 bg-blue-100 pt-1">
           <i class="fas fa-snowflake md:ml-2 lg:ml-10  xl:ml-14" style="color: green"></i>
            &nbsp;&nbsp; &nbsp; &nbsp;
            Integrate
            </jet-nav-link>
  </div>

  <div>
     <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-tools md:ml-2 lg:ml-10  xl:ml-14" style="color: purple"></i> 
           &nbsp;&nbsp; &nbsp; &nbsp; 
            <h4>Manage</h4>
        </div>
       </a>
  </div>
 <div>
     <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-star md:ml-2 lg:ml-10  xl:ml-14" style="color: orange"></i> 
           &nbsp;&nbsp; &nbsp; &nbsp;
            <h4>Report</h4>
        </div>
       </a>
  </div>
  <div>
     <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-chart-line md:ml-2 lg:ml-10  xl:ml-14" style="color: yellow"></i> 
           &nbsp;&nbsp; &nbsp; &nbsp; 
            <h4>Analyse</h4>
        </div>
       </a>
  </div>
  <div>
     <a href="" class="text">
    <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-sync-alt md:ml-2 lg:ml-10  xl:ml-14" style="color:green"></i> 
           &nbsp;&nbsp; &nbsp; &nbsp; 
            <h4>Syncronise</h4>
        </div>
       </a>
  </div>
  <div>
     <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-headset md:ml-2 lg:ml-10  xl:ml-14" style="color: indigo"></i> 
           &nbsp;&nbsp; &nbsp; &nbsp; 
            <h4>Services</h4>
        </div>
       </a>
  </div>
 <div>
     <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-puzzle-piece md:ml-2 lg:ml-10  xl:ml-14" style="color:color: rgb(236, 105, 127)"></i> 
           &nbsp;&nbsp; &nbsp; &nbsp; 
            <h4 title="Add-ons" id="content">Add-ons</h4>
        </div>
       </a>
  </div>
  <div>
     <a href="" class="text">
  <div class="d-flex justify-start box1 bg-blue-100 pt-1">
          <i class="fas fa-cubes md:ml-2 lg:ml-10  xl:ml-14" style="color: red"></i> 
           &nbsp;&nbsp; &nbsp; &nbsp; 
            <h4>Modules</h4>
        </div>
       </a>
  </div>
 
    </div>
    </div>

  
    <!-- Right Banner -->
    <div class="col-span-4  w-auto ">
      <div class="box bg-blue-100  " >
        <h4>aruvaa</h4>
        <p>lorem12</p>
      </div>

 <div class="container card-2 pt-1  pb-1 ">
        <h4>My Applications</h4>
 </div>
 <DxScrollView 
        direction="horizontal" 
        scrollByContent="true"
        scrollByThumb="true" 
        ShowScrollbar="never"
        id="scroll"  height="140px" width="100%">
      <div class="flex gap-2  ">
    
            <div class="box3 bg-blue-100 ">
                      <div class="text-1">
                        <h3>Coming Soon</h3>
                      </div>
                      <div class="icon-wrapper-1" style="color: orangered;">
                          <i class="fas fa-spa"></i>
                    </div>
            </div>
        <!-- card one --> 
            <div class="box3 bg-blue-100 ">
                    <div class="text-1">
                      <h3>Coming Soon</h3>
                    </div>
                    <div class="icon-wrapper-1" style="color: #03b5fc;">
                      <i class="fas fa-biohazard"></i>
                  </div>
            </div> 
        <!-- card one -->
            <div class="box3 bg-blue-100 ">
                    <div class="text-1">
                      <h3>Coming Soon</h3>
                    </div>
                    <div class="icon-wrapper-1" style="color: #fc03d7;">
                      <i class="fab fa-airbnb"></i>
                  </div>
            </div>  
        <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color:#fc034e;">
                   <i class="fab fa-atlassian"></i>
               </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: peru;">
                  <i class="fas fa-th"></i>
               </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100 ">
                <div class="text-1">
                  <h3>Coming Soon</h3>
                </div>
                <div class="icon-wrapper-1" style="color: rgb(49, 255, 66);">
                  <i class="fas fa-globe"></i> 
               </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: hotpink">
                <i class="fas fa-sun"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(238, 225, 41)">
                <i class="fas fa-asterisk"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(63, 196, 205)">
                <i class="fas fa-fan"></i>
              </div>
            </div>
            <!-- card one -->
            <div class="box3 bg-blue-100">
              <div class="text-1">
                <h3>Coming Soon</h3>
              </div>
              <div class="icon-wrapper-1" style="color: rgb(9, 109, 39)">
                <i class="fas fa-feather-alt"></i>
              </div>
            </div>
      
      </div>
 </DxScrollView>

 <!-- bottom card -->
  <DxScrollView 
        direction="vertical" 
        scrollByContent="true"
        scrollByThumb="true" 
        ShowScrollbar="never"
        id="scroll"  height="190px" width="100%">
<div class=" d-flex justify-start box-bottom bg-blue-100 mt-2 " >
    <div class="icon-wrapper" style="color: rgb(61, 124, 67);">
          <i class="fas fa-map"></i> 
    </div>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quam explicabo incidunt eum inventore vitae atque illo, minima temporibus, libero consequuntur ea laboriosam ad alias aperiam laborum architecto? Aut a molestiae accusamus necessitatibus vero aliquam?</p>
</div>

<div class="box-bottom bg-blue-100 mt-3 " >
    <div class="icon-wrapper" style="color: rgb(255, 5, 130)">
                <i class="fas fa-laptop"></i>
    </div>
        <!-- <h4>Description</h4> -->
</div>

<div class="box-bottom bg-blue-100 mt-3 " >
    <div class="icon-wrapper" style="color: rgb(255, 5, 130)">
                <i class="fas fa-laptop"></i>
    </div>
        <!-- <h4>Description</h4> -->
</div>

<div class="box-bottom bg-blue-100 mt-3 " >
    <div class="icon-wrapper" style="color: rgb(255, 5, 130)">
                <i class="fas fa-laptop"></i>
    </div>
        <!-- <h4>Description</h4> -->
</div>
</DxScrollView>

<!-- bottom cards end -->

 
  <DxToast
        v-model:visible="isVisible"
        v-model:message="messag"
        v-model:type="type"
      />
    </div>

 </div>
  <!-- </div> -->
</template>
<script>
import { DxToast } from 'devextreme-vue/toast';
import DxScrollView from 'devextreme-vue/scroll-view';
import JetResponsiveNavLink from '@/Jetstream/ResponsiveNavLink.vue';
import JetNavLink from '@/Jetstream/NavLink.vue';
import {getConfigurationCredentials} from './Utils/js/dashboard/dashboard.js';
import {isElectron} from './Utils/js/utils/utils.js';
var _this;

export default {
  props:["message","license_no"],
  components: {
      DxScrollView ,
      JetResponsiveNavLink,
      DxToast,
      JetNavLink,
  },
  data() {
    return {
      isVisible: false,
      messag: '',
      type: 'info',
      url:"",
      port:"",
      metas:'',
      is_valid_license:"",
      tally_is_open:"",
      is_electron:""
    };
  },
  methods: {
      logout(){
           this.$inertia.post(route('logout'));
      },
      checkIntegrate(){
           this.$inertia.post(route('integrate',{'is_valid_license':this.is_valid_license}));
      },
  },
  mounted(){
      var _this=this;
      if(isElectron()){
          this.messag = this.message;
          if(this.messag == "You Dont have a valid license number for this service"){
             this.isVisible = true; 
          }
          this.is_electron = true;
          this.metas = "electron";
          window.api.send('checkTallyOpening'); 
          window.api.receive("checkTallyOpening-reply", (tally_response) => {
                 if(tally_response == "tally is not open"){
                      this.tally_is_open = false;
                      this.messag = tally_response;
                      this.isVisible = true;
                 }
                 else if(tally_response == "tally is open"){
                      this.tally_is_open = true;
                      getConfigurationCredentials(_this,this.metas,this.license_no);
                 }
          });
      }
      else{
          this.is_electron = false;
          this.messag = this.message;
          if(this.messag == "You Dont have a valid license number for this service"){
            this.isVisible = true; 
          }
           axios.post('/checkTallyIsOpen')
            .then((result) => {
                if(result.data!="not_open"){
                      this.tally_is_open = true;
                }
                else{
                      this.tally_is_open = false;
                      this.messag = "tally is not open";
                      this.isVisible = true;
                }
            })
      }
  },
  created:function(){
          
        
    console.log('hudj');
      // var _this=this;
      // document.cookie = "content=vue;";
      // // Tell Vue to use the plugin
      // if(document.cookie.length!=0)
      // { 
      //       this.metas=this.getCookie();
      //       getConfigurationCredentials(this.metas,_this.user_license_credentials);
      // }
      // this.license_no="12345678";
      // this.url="http://192.168.2.111";
      // this.port="9000"; 
      // this.messag = this.message;
      // if(this.messag != null){
      //     this.isVisible = true;
      // }
  }
}
</script>
<style scoped>
#content {
overflow: hidden;
width:100px;
display: -webkit-box;
-webkit-line-clamp: 1;
-webkit-box-orient: vertical;
}
/* #content  h4{
  color: #191c23;
  font-size: 17px;
} */
/* Red border */
hr.new1 {
  border-top: 1px solid grey;
}
@media only screen and (min-width: 992px){
  .box5-grid{
   display: none;
 }

/* Large devices (tab, 952px and up) */
@media  (max-width: 992px){
 .box-grid{
   display: none;
 }  
}
@media only screen and (min-width: 992px){
  .box5-grid{
   display: none;
 }
}
}
 .box5 {
  height: 102px;
  width: 100px;
  border: 2px solid rgb(121, 226, 226);
}
@media (min-width: 768px) {
  .box1 {
    height: 10px;
    width: auto;
  }
  .cad {
    /* padding: 38px 10px; */
    justify-content: space-between;
    margin-right: 1px;
    /* margin-left: 10px; */
  }
}
.text-1 h3 {
  font-size: 17px;
  padding-top: 5px;
  text-decoration: none;
  margin-left: 10px;
  text-align: left;
  color: #191c23;
  /* margin-bottom: 4px; */
}
/* For desktop view */
.firstbox{
   border: 2px solid rgb(121, 226, 226);
   height: 160px;
   padding: 30px;
   /* width: auto; */
}
.box {
  padding: 40px;
  /* margin-left: 13px; */
  height: auto;
  width: 100%;
  border: 2px solid rgb(121, 226, 226);
}

.box-bottom {
  padding: 20px;
  /* margin-left: 13px; */
  height: auto;
  width: 100%;
  border: 2px solid rgb(121, 226, 226);
}

.box1 {
  height: 32px;
  width: auto;
  border: 1px solid rgb(121, 226, 226);
  /* text-decoration: none:  !important; */
}

.icon-wrapper {
  font-size: xx-large;
}

/* .banner{
 margin-right: 50px; 
} */
.text h4 {
  font-size: 15px;
  text-decoration: none;
  color: #191c23;
}
a .text h3 {
  text-decoration: none;
}
#content {
  overflow: hidden;
  width: 100px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
#content h3 {
  color: #191c23;
  font-size: 15px;
  margin-left: 8px;
}
.box3 {
  height: 133px;
  width: 113px;
  border: 2px solid rgb(121, 226, 226);
}
.icon-wrapper-1 {
  margin: auto;
  text-align: center;
  font-size: 30px;
  margin-top: 30px;
}
/* right banner */
.cad {
  /* padding: 38px 10px; */
  border-radius: 10px;
  color: #2567b3;
  justify-content: space-between;
  margin-right: 110px;
  /* margin-left: 10px; */
}
.card-2 h4{
text-align: start;
}
/* right scrooll  card */
</style>

